document.addEventListener('DOMContentLoaded', function() {
  const toggleButtons = document.querySelectorAll('.mobile-footer-toggle');
  const headingWrappers = document.querySelectorAll('.footer-heading-wrapper');
  
  function closeAllAccordions(exceptThis) {
    document.querySelectorAll('.mobile-footer-content').forEach(content => {
      if (content !== exceptThis) {
        content.classList.remove('active');
        const button = content.parentElement.querySelector('.mobile-footer-toggle');
        if (button) button.classList.remove('active');
      }
    });
  }

  function handleAccordionClick(e) {
    const section = this.closest('.mobile-footer-section');
    const content = section.querySelector('.mobile-footer-content');
    const button = section.querySelector('.mobile-footer-toggle');
    
    // Close other accordions
    closeAllAccordions(content);
    
    // Toggle current accordion
    content.classList.toggle('active');
    button.classList.toggle('active');
  }

  // Add click handlers to both buttons and heading wrappers
  headingWrappers.forEach(wrapper => {
    wrapper.addEventListener('click', handleAccordionClick);
  });

  toggleButtons.forEach(button => {
    button.addEventListener('click', function(e) {
      e.stopPropagation(); // Prevent double triggering with heading wrapper click
      handleAccordionClick.call(this.closest('.footer-heading-wrapper'));
    });
  });
}); 